export const sentenceTransitionTimings = {
	"qaneryaurci-2-5-1-1-a":[],
	"qaneryaurci-2-5-1-2-b":[1000],
	"qaneryaurci-2-5-1-3-a":[],
	"qaneryaurci-2-5-1-4-b":[],
	"qaneryaurci-2-5-2-1-a":[],
	"qaneryaurci-2-5-2-2-b":[],
	"qaneryaurci-2-5-2-3-a":[],
	"qaneryaurci-2-5-2-4-b":[],
	"qaneryaurci-2-8-1-1-a":[],
	"qaneryaurci-2-8-1-2-b":[],
	"qaneryaurci-2-8-1-2-b-2":[],
	"qaneryaurci-2-8-2-1-a":[],
	"qaneryaurci-2-8-2-2-b":[],
	"qaneryaurci-2-8-2-2-b-2":[],
	"qaneryaurci-2-8-2-3-a":[],
	"qaneryaurci-2-8-3-1-a":[],
	"qaneryaurci-2-8-3-2-b":[],
	"qaneryaurci-2-8-3-3-a":[],
	"qaneryaurci-2-8-3-4-b":[],
	"qaneryaurci-2-8-4-1-a":[],
	"qaneryaurci-2-8-4-2-b":[],
	"qaneryaurci-2-8-5-1-a":[],
	"qaneryaurci-2-8-5-2-b":[],
	"qaneryaurci-2-8-5-3-a":[],
	"qaneryaurci-2-8-5-4-b":[],
	"qaneryaurci-2-8-5-5-a":[],
	"qaneryaurci-2-14-1-1-a":[],
	"qaneryaurci-2-14-1-2-b":[],
	"qaneryaurci-2-14-1-2-b-2":[],
	"qaneryaurci-2-14-2-1-a":[],
	"qaneryaurci-2-14-2-2-b":[],
	"qaneryaurci-2-14-2-2-b-2":[],
	"qaneryaurci-2-14-3-1-a":[],
	"qaneryaurci-2-14-3-2-b":[],
	"qaneryaurci-2-14-3-3-a":[],
	"qaneryaurci-2-14-3-4-b":[],
	"qaneryaurci-2-14-4-1-a":[],
	"qaneryaurci-2-14-4-2-b":[],
	"qaneryaurci-2-14-4-3-a":[],
	"qaneryaurci-2-14-4-4-b":[],
	"qaneryaurci-2-14-5-1-a":[],
	"qaneryaurci-2-14-5-2-b":[],
	"qaneryaurci-2-14-5-3-a":[],
	"qaneryaurci-2-14-5-4-b":[],
	"qaneryaurci-2-14-6-1-a":[],
	"qaneryaurci-2-14-6-2-b":[],
	"qaneryaurci-2-14-6-3-a":[],
	"qaneryaurci-2-14-6-4-b":[],
	"qaneryaurci-2-14-6-5-a":[],
	"qaneryaurci-2-14-7-1-a":[],
	"qaneryaurci-2-14-7-2-b":[],
	"qaneryaurci-2-14-7-3-a":[],
	"qaneryaurci-2-14-7-4-b":[],
	"qaneryaurci-2-14-8-1-a":[],
	"qaneryaurci-2-14-8-2-b":[],
	"qaneryaurci-2-14-8-3-a":[],
	"qaneryaurci-2-14-8-4-b":[],
	"qaneryaurci-2-19-1-1-a":[],
	"qaneryaurci-2-19-1-2-b":[],
	"qaneryaurci-2-19-2-1-a":[],
	"qaneryaurci-2-19-2-2-b":[],
	"qaneryaurci-2-19-3-1-a":[],
	"qaneryaurci-2-19-3-2-b":[],
	"qaneryaurci-2-19-4-1-a":[],
	"qaneryaurci-2-19-4-2-b":[],
	"qaneryaurci-2-19-5-1-a":[],
	"qaneryaurci-2-19-5-2-b":[],
	"qaneryaurci-2-19-6-1-a":[],
	"qaneryaurci-2-19-6-2-b":[],
	"qaneryaurci-2-19-7-1-a":[],
	"qaneryaurci-2-19-7-2-b":[],
	"qaneryaurci-2-19-8-1-a":[],
	"qaneryaurci-2-19-8-2-b":[],
	"qaneryaurci-3-3-1-1-a":[],
	"qaneryaurci-3-3-1-2-b":[],
	"qaneryaurci-3-3-2-1-a":[],
	"qaneryaurci-3-3-2-2-b":[],
	"qaneryaurci-3-3-2-2-b-2":[],
	"qaneryaurci-3-3-3-1-a":[],
	"qaneryaurci-3-3-3-1-a-2":[],
	"qaneryaurci-3-3-3-2-b":[],
	"qaneryaurci-3-3-4-1-a":[],
	"qaneryaurci-3-3-4-2-b":[],
	"qaneryaurci-3-3-5-1-a":[],
	"qaneryaurci-3-3-5-2-b":[],
	"qaneryaurci-3-3-5-2-b-2":[],
	"qaneryaurci-3-3-6-1-a":[],
	"qaneryaurci-3-3-6-2-b":[],
	"qaneryaurci-3-3-7-1-a":[],
	"qaneryaurci-3-3-7-2-b":[],
	"qaneryaurci-3-3-7-2-b-2":[],
	"qaneryaurci-3-3-8-1-a":[],
	"qaneryaurci-3-3-8-2-b":[],
	"qaneryaurci-3-3-9-1-a":[],
	"qaneryaurci-3-3-9-2-b":[],
	"qaneryaurci-3-3-9-3-a":[],
	"qaneryaurci-3-3-9-4-b":[],
	"qaneryaurci-3-4-1-1-a":[],
	"qaneryaurci-3-4-1-2-b":[],
	"qaneryaurci-3-4-1-2-b-2":[],
	"qaneryaurci-3-4-2-1-a":[],
	"qaneryaurci-3-4-2-2-b":[],
	"qaneryaurci-3-4-3-1-a":[],
	"qaneryaurci-3-4-3-2-b":[],
	"qaneryaurci-3-4-4-1-a":[],
	"qaneryaurci-3-4-4-1-a-2":[],
	"qaneryaurci-3-4-4-1-a-3":[],
	"qaneryaurci-3-4-4-2-b":[],
	"qaneryaurci-3-4-4-2-b-2":[],
	"qaneryaurci-3-4-5-1-a":[],
	"qaneryaurci-3-4-5-2-b":[],
	"qaneryaurci-3-4-5-2-b-2":[],
	"qaneryaurci-3-4-6-1-a":[],
	"qaneryaurci-3-4-6-1-a-2":[],
	"qaneryaurci-3-4-6-2-b":[],
	"qaneryaurci-3-4-7-1-a":[],
	"qaneryaurci-3-4-7-2-b":[],
	"qaneryaurci-3-4-8-1-a":[],
	"qaneryaurci-3-4-8-2-b":[],
	"qaneryaurci-3-4-9-1-a":[],
	"qaneryaurci-3-4-9-2-b":[],
	"qaneryaurci-3-4-10-1-a":[],
	"qaneryaurci-3-4-10-1-a-2":[],
	"qaneryaurci-3-4-10-2-b":[],
	"qaneryaurci-3-4-11-1-a":[],
	"qaneryaurci-3-4-11-2-b":[],
	"qaneryaurci-3-4-12-1-a":[],
	"qaneryaurci-3-4-12-2-b":[],
	"qaneryaurci-3-4-13-1-a":[],
	"qaneryaurci-3-4-13-2-b":[],
	"qaneryaurci-3-4-14-1-a":[],
	"qaneryaurci-3-4-14-2-b":[],
	"qaneryaurci-3-4-15-1-a":[],
	"qaneryaurci-3-4-15-2-b":[],
	"qaneryaurci-3-4-16-1-a":[],
	"qaneryaurci-3-4-16-2-b":[],
	"qaneryaurci-3-4-17-1-a":[],
	"qaneryaurci-3-4-17-2-b":[],
	"qaneryaurci-3-4-18-1-a":[],
	"qaneryaurci-3-4-18-2-b":[],
	"qaneryaurci-3-4-19-1-a":[],
	"qaneryaurci-3-4-19-2-b":[],
	"qaneryaurci-3-4-20-1-a":[],
	"qaneryaurci-3-4-20-2-b":[],
	"qaneryaurci-3-4-21-1-a":[],
	"qaneryaurci-3-4-21-2-b":[],
	"qaneryaurci-3-4-22-1-a":[],
	"qaneryaurci-3-4-22-2-b":[],
	"qaneryaurci-3-8-1-1-a":[],
	"qaneryaurci-3-8-1-2-b":[],
	"qaneryaurci-3-8-1-2-b-2":[],
	"qaneryaurci-3-8-2-1-a":[],
	"qaneryaurci-3-8-2-2-b":[],
	"qaneryaurci-3-8-3-1-a":[],
	"qaneryaurci-3-8-3-2-b":[],
	"qaneryaurci-3-8-4-1-a":[],
	"qaneryaurci-3-8-4-2-b":[],
	"qaneryaurci-3-8-4-2-b-2":[],
	"qaneryaurci-3-8-5-1-a":[],
	"qaneryaurci-3-8-5-2-b":[],
	"qaneryaurci-3-8-6-1-a":[],
	"qaneryaurci-3-8-6-2-b":[],
	"qaneryaurci-3-14-1-1-a":[],
	"qaneryaurci-3-14-1-2-b":[],
	"qaneryaurci-3-14-2-1-a":[],
	"qaneryaurci-3-14-2-2-b":[],
	"qaneryaurci-3-14-2-2-b-2":[],
	"qaneryaurci-3-14-2-3-a":[],
	"qaneryaurci-3-14-2-4-b":[],
	"qaneryaurci-3-14-2-5-a":[],
	"qaneryaurci-3-14-2-6-b":[],
	"qaneryaurci-3-14-3-1-a":[],
	"qaneryaurci-3-14-3-2-b":[],
	"qaneryaurci-3-14-3-2-b-2":[],
	"qaneryaurci-3-14-4-1-a":[],
	"qaneryaurci-3-14-4-2-b":[],
	"qaneryaurci-3-14-5-1-a":[],
	"qaneryaurci-3-14-5-2-b":[],
	"qaneryaurci-3-14-6-1-a":[],
	"qaneryaurci-3-14-6-2-b":[],
	"qaneryaurci-3-14-6-2-b-2":[],
	"qaneryaurci-3-14-7-1-a":[],
	"qaneryaurci-3-14-7-2-b":[],
	"qaneryaurci-3-14-8-1-a":[],
	"qaneryaurci-3-14-8-2-b":[],
	"qaneryaurci-3-14-9-1-a":[],
	"qaneryaurci-3-14-9-2-b":[],
	"qaneryaurci-3-14-9-3-a":[],
	"qaneryaurci-3-14-9-4-b":[],
	"qaneryaurci-3-14-10-1-a":[],
	"qaneryaurci-3-14-10-2-b":[],
	"qaneryaurci-3-14-11-1-a":[],
	"qaneryaurci-3-14-11-2-b":[],
	"qaneryaurci-3-21-1-1-a":[],
	"qaneryaurci-3-21-1-2-b":[],
	"qaneryaurci-3-21-2-1-a":[],
	"qaneryaurci-3-21-2-2-b":[],
	"qaneryaurci-3-21-2-2-b-2":[],
	"qaneryaurci-3-21-3-1-a":[],
	"qaneryaurci-3-21-3-2-b":[],
	"qaneryaurci-3-21-3-2-b-2":[],
	"qaneryaurci-3-21-4-1-a":[],
	"qaneryaurci-3-21-4-2-b":[],
	"qaneryaurci-3-21-5-1-a":[],
	"qaneryaurci-3-21-5-2-b":[],
	"qaneryaurci-3-21-5-2-b-2":[],
	"qaneryaurci-3-21-6-1-a":[],
	"qaneryaurci-3-21-6-2-b":[],
	"qaneryaurci-3-21-6-2-b-2":[],
	"qaneryaurci-3-21-7-1-a":[],
	"qaneryaurci-3-21-7-2-b":[],
	"qaneryaurci-3-21-8-1-a":[],
	"qaneryaurci-3-21-8-2-b":[],
	"qaneryaurci-3-21-9-1-a":[],
	"qaneryaurci-3-21-9-2-b":[],
	"qaneryaurci-3-21-10-1-a":[],
	"qaneryaurci-3-21-10-2-b":[],
	"qaneryaurci-3-21-10-2-b-2":[],
	"qaneryaurci-3-22-1-1-a":[],
	"qaneryaurci-3-22-1-2-b":[],
	"qaneryaurci-3-22-1-3-a":[],
	"qaneryaurci-3-22-1-4-b":[],
	"qaneryaurci-3-22-1-5-a":[],
	"qaneryaurci-3-22-1-6-b":[],
	"qaneryaurci-4-2-1-1-a":[],
	"qaneryaurci-4-2-1-2-b":[],
	"qaneryaurci-4-2-1-3-a":[],
	"qaneryaurci-4-2-1-4-b":[],
	"qaneryaurci-4-2-2-1-a":[],
	"qaneryaurci-4-2-2-2-b":[],
	"qaneryaurci-4-2-2-3-a":[],
	"qaneryaurci-4-2-2-4-b":[],
	"qaneryaurci-4-2-3-1-a":[],
	"qaneryaurci-4-2-3-2-b":[],
	"qaneryaurci-4-2-3-3-a":[],
	"qaneryaurci-4-2-3-4-b":[],
	"qaneryaurci-4-2-4-1-a":[],
	"qaneryaurci-4-2-4-2-b":[],
	"qaneryaurci-4-2-4-3-a":[],
	"qaneryaurci-4-2-4-4-b":[],
	"qaneryaurci-4-6-1-1-a":[],
	"qaneryaurci-4-6-1-2-b":[],
	"qaneryaurci-4-6-1-2-b-2":[],
	"qaneryaurci-4-6-2-1-a":[],
	"qaneryaurci-4-6-2-2-b":[],
	"qaneryaurci-4-6-2-2-b-2":[],
	"qaneryaurci-4-6-3-1-a":[],
	"qaneryaurci-4-6-3-2-b":[],
	"qaneryaurci-4-6-4-1-a":[],
	"qaneryaurci-4-6-4-2-b":[],
	"qaneryaurci-4-6-5-1-a":[],
	"qaneryaurci-4-6-5-2-b":[],
	"qaneryaurci-4-6-6-1-a":[],
	"qaneryaurci-4-6-6-2-b":[],
	"qaneryaurci-4-6-6-2-b-2":[],
	"qaneryaurci-4-6-7-1-a":[],
	"qaneryaurci-4-6-7-2-b":[],
	"qaneryaurci-4-6-7-3-a":[],
	"qaneryaurci-4-6-7-4-b":[],
	"qaneryaurci-4-6-7-4-b-2":[],
	"qaneryaurci-4-6-8-1-a":[],
	"qaneryaurci-4-6-8-2-b":[],
	"qaneryaurci-4-6-8-3-a":[],
	"qaneryaurci-4-6-8-4-b":[],
	"qaneryaurci-4-6-9-1-a":[],
	"qaneryaurci-4-6-9-2-b":[],
	"qaneryaurci-4-6-9-3-a":[],
	"qaneryaurci-4-6-9-4-b":[],
	"qaneryaurci-4-6-10-1-a":[],
	"qaneryaurci-4-6-10-2-b":[],
	"qaneryaurci-4-6-11-1-a":[],
	"qaneryaurci-4-6-11-2-b":[],
	"qaneryaurci-4-6-11-3-a":[],
	"qaneryaurci-4-6-11-4-b":[],
	"qaneryaurci-4-6-12-1-a":[],
	"qaneryaurci-4-6-12-2-b":[],
	"qaneryaurci-4-6-12-2-b-2":[],
	"qaneryaurci-4-6-12-2-b-3":[],
	"qaneryaurci-4-6-12-3-a":[],
	"qaneryaurci-4-6-12-4-b":[],
	"qaneryaurci-4-6-12-4-b-2":[],
	"qaneryaurci-4-15-1-1-a":[],
	"qaneryaurci-4-15-1-2-b":[],
	"qaneryaurci-4-15-1-3-a":[],
	"qaneryaurci-4-15-2-1-a":[],
	"qaneryaurci-4-15-2-2-b":[],
	"qaneryaurci-4-15-2-3-a":[],
	"qaneryaurci-4-15-2-4-b":[],
	"qaneryaurci-4-15-2-5-a":[],
	"qaneryaurci-4-15-2-6-b":[],
	"qaneryaurci-4-15-2-7-a":[],
	"qaneryaurci-4-15-3-1-a":[],
	"qaneryaurci-4-15-3-2-b":[],
	"qaneryaurci-4-15-3-3-a":[],
	"qaneryaurci-4-15-3-4-b":[],
	"qaneryaurci-4-15-3-5-a":[],
	"qaneryaurci-4-15-3-6-b":[],
	"qaneryaurci-4-15-3-7-a":[],
	"qaneryaurci-4-15-3-8-b":[],
	"qaneryaurci-4-15-4-1-a":[1400],
	"qaneryaurci-4-15-4-2-b":[1100],
	"qaneryaurci-4-15-4-2-b-2":[],
	"qaneryaurci-4-15-4-3-a":[500],
	"qaneryaurci-4-15-4-3-a-2":[500],
	"qaneryaurci-4-15-4-4-b":[1200],
	"qaneryaurci-4-15-4-4-b-2":[1300],
	"qaneryaurci-4-15-4-5-a":[],
	"qaneryaurci-4-15-4-6-b":[800],
	"qaneryaurci-4-15-5-1-a":[],
	"qaneryaurci-4-15-5-2-b":[],
	"qaneryaurci-4-15-5-2-b-2":[],
	"qaneryaurci-4-15-6-1-a":[],
	"qaneryaurci-4-15-6-2-b":[],
	"qaneryaurci-4-15-6-3-a":[],
	"qaneryaurci-4-15-7-1-a":[],
	"qaneryaurci-4-15-7-2-b":[],
	"qaneryaurci-4-15-7-2-b-2":[],
	"qaneryaurci-4-15-7-3-a":[],
	"qaneryaurci-4-15-7-4-b":[],
	"qaneryaurci-4-15-7-5-a":[],
	"qaneryaurci-4-15-8-1-a":[],
	"qaneryaurci-4-15-8-2-b":[],
	"qaneryaurci-4-15-9-1-a":[],
	"qaneryaurci-4-15-9-2-b":[],
	"qaneryaurci-4-15-9-3-a":[],
	"qaneryaurci-4-15-9-4-b":[],
	"qaneryaurci-4-21-1-1-a":[],
	"qaneryaurci-4-21-1-2-b":[],
	"qaneryaurci-4-21-1-3-a":[],
	"qaneryaurci-4-21-1-4-b":[],
	"qaneryaurci-4-21-1-5-a":[],
	"qaneryaurci-4-21-2-1-a":[],
	"qaneryaurci-4-21-2-2-b":[],
	"qaneryaurci-4-21-2-3-a":[],
	"qaneryaurci-4-21-2-4-b":[],
	"qaneryaurci-4-21-2-5-a":[],
	"qaneryaurci-4-21-2-6-b":[],
	"qaneryaurci-4-21-3-1-a":[],
	"qaneryaurci-4-21-3-2-b":[],
	"qaneryaurci-4-21-3-3-a":[],
	"qaneryaurci-4-21-4-1-a":[],
	"qaneryaurci-4-21-4-2-b":[],
	"qaneryaurci-4-21-4-3-a":[],
	"qaneryaurci-4-21-4-4-b":[],
	"qaneryaurci-4-21-4-5-a":[],
	"qaneryaurci-4-21-5-1-a":[],
	"qaneryaurci-4-21-5-2-b":[],
	"qaneryaurci-4-21-5-3-a":[],
	"qaneryaurci-4-21-5-4-b":[],
	"qaneryaurci-4-21-5-5-a":[],
	"qaneryaurci-4-21-5-6-b":[],
	"qaneryaurci-4-21-6-1-a":[],
	"qaneryaurci-4-21-6-2-b":[],
	"qaneryaurci-4-21-6-3-a":[],
	"qaneryaurci-4-21-6-4-b":[],
	"qaneryaurci-4-21-7-1-a":[],
	"qaneryaurci-4-21-7-2-b":[],
	"qaneryaurci-4-21-7-3-a":[],
	"qaneryaurci-4-21-7-4-b":[],
	"qaneryaurci-4-21-7-5-a":[],
	"qaneryaurci-4-21-7-6-b":[],
	"qaneryaurci-4-21-7-7-a":[],
	"qaneryaurci-4-21-8-1-a":[],
	"qaneryaurci-4-21-8-2-b":[],
	"qaneryaurci-4-21-8-3-a":[],
	"qaneryaurci-4-21-8-4-b":[],
	"qaneryaurci-5-2-1-1-a":[],
	"qaneryaurci-5-2-1-2-b":[],
	"qaneryaurci-5-2-1-3-a":[],
	"qaneryaurci-5-2-1-4-b":[],
	"qaneryaurci-5-2-1-5-a":[],
	"qaneryaurci-5-2-1-6-b":[],
	"qaneryaurci-5-2-1-7-a":[],
	"qaneryaurci-5-2-1-8-b":[],
	"qaneryaurci-5-2-2-1-a":[],
	"qaneryaurci-5-2-2-2-b":[],
	"qaneryaurci-5-2-2-3-a":[],
	"qaneryaurci-5-2-2-4-b":[],
	"qaneryaurci-5-2-3-1-a":[],
	"qaneryaurci-5-2-3-2-b":[],
	"qaneryaurci-5-2-3-2-b-2":[],
	"qaneryaurci-5-2-3-3-a":[],
	"qaneryaurci-5-2-3-4-b":[],
	"qaneryaurci-5-2-3-4-b-2":[],
	"qaneryaurci-5-2-4-1-a":[],
	"qaneryaurci-5-2-4-2-b":[],
	"qaneryaurci-5-2-4-3-a":[],
	"qaneryaurci-5-2-4-4-b":[],
	"qaneryaurci-5-2-4-5-a":[],
	"qaneryaurci-5-2-4-6-b":[],
	"qaneryaurci-5-2-4-7-a":[],
	"qaneryaurci-5-2-4-8-b":[],
	"qaneryaurci-5-2-4-9-a":[],
	"qaneryaurci-5-2-5-1-a":[],
	"qaneryaurci-5-2-5-2-b":[],
	"qaneryaurci-5-2-5-3-a":[],
	"qaneryaurci-5-2-5-4-b":[],
	"qaneryaurci-5-2-5-5-a":[],
	"qaneryaurci-5-2-5-6-b":[],
	"qaneryaurci-5-2-5-7-a":[],
	"qaneryaurci-5-2-5-8-b":[],
	"qaneryaurci-5-2-5-9-a":[],
	"qaneryaurci-5-2-5-10-b":[],
	"qaneryaurci-5-6-1-1-a":[],
	"qaneryaurci-5-6-1-2-b":[],
	"qaneryaurci-5-6-1-3-a":[],
	"qaneryaurci-5-6-1-4-b":[],
	"qaneryaurci-5-6-1-5-a":[],
	"qaneryaurci-5-6-1-6-b":[],
	"qaneryaurci-5-6-2-1-a":[],
	"qaneryaurci-5-6-2-2-b":[],
	"qaneryaurci-5-6-2-3-a":[],
	"qaneryaurci-5-6-2-4-b":[],
	"qaneryaurci-5-6-2-5-a":[],
	"qaneryaurci-5-6-3-1-a":[],
	"qaneryaurci-5-6-3-2-b":[],
	"qaneryaurci-5-6-3-3-a":[],
	"qaneryaurci-5-6-3-4-b":[],
	"qaneryaurci-5-6-3-5-a":[],
	"qaneryaurci-5-6-4-1-a":[],
	"qaneryaurci-5-6-4-2-b":[],
	"qaneryaurci-5-6-4-3-a":[],
	"qaneryaurci-5-6-4-4-b":[],
	"qaneryaurci-5-6-4-5-a":[],
	"qaneryaurci-5-6-4-6-b":[],
	"qaneryaurci-5-6-4-7-a":[],
	"qaneryaurci-5-6-5-1-a":[],
	"qaneryaurci-5-6-5-2-b":[],
	"qaneryaurci-5-6-5-3-a":[],
	"qaneryaurci-5-6-5-4-b":[],
	"qaneryaurci-5-6-5-5-a":[],
	"qaneryaurci-5-11-1-1-a":[],
	"qaneryaurci-5-11-1-2-b":[],
	"qaneryaurci-5-11-1-3-a":[],
	"qaneryaurci-5-11-1-4-b":[],
	"qaneryaurci-5-11-1-5-a":[],
	"qaneryaurci-5-11-2-1-a":[],
	"qaneryaurci-5-11-2-2-b":[],
	"qaneryaurci-5-11-2-3-a":[],
	"qaneryaurci-5-11-2-4-b":[],
	"qaneryaurci-5-11-3-1-a":[],
	"qaneryaurci-5-11-3-2-b":[],
	"qaneryaurci-5-11-3-3-a":[],
	"qaneryaurci-5-11-3-4-b":[],
	"qaneryaurci-5-11-3-5-a":[],
	"qaneryaurci-5-11-3-6-b":[],
	"qaneryaurci-5-11-3-7-a":[],
	"qaneryaurci-5-11-3-8-b":[],
	"qaneryaurci-5-11-4-1-a":[],
	"qaneryaurci-5-11-4-2-b":[],
	"qaneryaurci-5-11-4-3-a":[],
	"qaneryaurci-5-11-4-4-b":[],
	"qaneryaurci-5-15-1-1-a":[],
	"qaneryaurci-5-15-1-2-b":[],
	"qaneryaurci-5-15-1-3-a":[],
	"qaneryaurci-5-15-1-4-b":[],
	"qaneryaurci-5-15-1-5-a":[],
	"qaneryaurci-5-15-1-6-b":[],
	"qaneryaurci-5-15-1-7-a":[],
	"qaneryaurci-5-15-1-8-b":[],
	"qaneryaurci-5-15-2-1-a":[500,1500],
	"qaneryaurci-5-15-2-2-b":[500,1800],
	"qaneryaurci-5-15-2-3-a":[1100],
	"qaneryaurci-5-15-2-4-b":[1000,1700,2500],
	"qaneryaurci-5-15-2-5-a":[500,900,2400],
	"qaneryaurci-5-15-2-6-b":[600,1300,1700],
	"qaneryaurci-5-15-2-7-a":[700,1800,2500],
	"qaneryaurci-5-15-2-8-b":[2700,3400,4200],
	"qaneryaurci-5-15-2-9-a":[],
	"qaneryaurci-5-15-3-1-a":[],
	"qaneryaurci-5-15-3-2-b":[],
	"qaneryaurci-5-15-3-3-a":[],
	"qaneryaurci-5-15-3-4-b":[],
	"qaneryaurci-5-15-3-5-a":[],
	"qaneryaurci-5-15-3-6-b":[],
	"qaneryaurci-5-15-4-1-a":[],
	"qaneryaurci-5-15-4-2-b":[],
	"qaneryaurci-5-15-4-3-a":[],
	"qaneryaurci-5-15-4-4-b":[],
	"qaneryaurci-5-15-4-5-a":[],
	"qaneryaurci-5-15-4-6-b":[],
	"qaneryaurci-6-2-1-1-a":[],
	"qaneryaurci-6-2-1-2-b":[],
	"qaneryaurci-6-2-1-3-a":[],
	"qaneryaurci-6-2-1-4-b":[],
	"qaneryaurci-6-2-1-5-c":[],
	"qaneryaurci-6-2-1-6-a":[],
	"qaneryaurci-6-2-1-7-c":[],
	"qaneryaurci-6-2-1-8-a":[],
	"qaneryaurci-6-2-2-1-a":[],
	"qaneryaurci-6-2-2-2-b":[],
	"qaneryaurci-6-2-2-3-a":[],
	"qaneryaurci-6-2-2-4-b":[],
	"qaneryaurci-6-2-2-5-a":[],
	"qaneryaurci-6-2-2-6-b":[],
	"qaneryaurci-6-2-3-1-a":[],
	"qaneryaurci-6-2-3-2-b":[],
	"qaneryaurci-6-2-3-3-a":[],
	"qaneryaurci-6-2-3-4-b":[],
	"qaneryaurci-6-2-4-1-a":[],
	"qaneryaurci-6-2-4-2-b":[],
	"qaneryaurci-6-2-4-3-a":[],
	"qaneryaurci-6-2-4-4-b":[],
	"qaneryaurci-6-2-4-5-a":[],
	"qaneryaurci-6-2-4-6-b":[],
	"qaneryaurci-6-2-4-7-a":[],
	"qaneryaurci-6-2-4-8-b":[],
	"qaneryaurci-6-2-4-9-a":[],
	"qaneryaurci-6-2-4-10-b":[],
	"qaneryaurci-6-2-5-1-a":[],
	"qaneryaurci-6-2-5-2-b":[],
	"qaneryaurci-6-2-5-3-a":[],
	"qaneryaurci-6-2-5-4-b":[],
	"qaneryaurci-6-7-1-1-a":[],
	"qaneryaurci-6-7-1-2-b":[],
	"qaneryaurci-6-7-1-3-a":[],
	"qaneryaurci-6-7-1-4-b":[],
	"qaneryaurci-6-7-1-5-a":[],
	"qaneryaurci-6-7-1-6-b":[],
	"qaneryaurci-6-7-1-7-a":[],
	"qaneryaurci-6-7-1-8-b":[],
	"qaneryaurci-6-7-1-9-a":[],
	"qaneryaurci-6-7-1-10-b":[],
	"qaneryaurci-6-7-1-11-a":[],
	"qaneryaurci-6-7-1-12-b":[],
	"qaneryaurci-6-7-2-1-a":[],
	"qaneryaurci-6-7-2-2-b":[],
	"qaneryaurci-6-7-2-3-a":[],
	"qaneryaurci-6-7-2-4-b":[],
	"qaneryaurci-6-7-2-5-a":[],
	"qaneryaurci-6-7-2-6-b":[],
	"qaneryaurci-6-7-3-1-a":[],
	"qaneryaurci-6-7-3-2-b":[],
	"qaneryaurci-6-7-3-3-a":[],
	"qaneryaurci-6-7-3-4-b":[],
	"qaneryaurci-6-7-3-5-a":[],
	"qaneryaurci-6-7-4-1-a":[],
	"qaneryaurci-6-7-4-2-b":[],
	"qaneryaurci-6-7-4-3-a":[],
	"qaneryaurci-6-7-4-4-b":[],
	"qaneryaurci-6-7-4-5-a":[],
	"qaneryaurci-6-7-4-6-b":[],
	"qaneryaurci-6-7-4-7-a":[],
	"qaneryaurci-6-7-4-8-b":[],
	"qaneryaurci-6-7-4-9-a":[],
	"qaneryaurci-6-7-4-10-b":[],
	"qaneryaurci-6-7-4-11-a":[],
	"qaneryaurci-6-13-1-1-a":[],
	"qaneryaurci-6-13-1-2-b":[],
	"qaneryaurci-6-13-1-3-a":[],
	"qaneryaurci-6-13-1-4-b":[],
	"qaneryaurci-6-13-1-5-a":[],
	"qaneryaurci-6-13-1-6-b":[],
	"qaneryaurci-6-13-1-7-a":[],
	"qaneryaurci-6-13-1-8-b":[],
	"qaneryaurci-6-13-1-9-a":[],
	"qaneryaurci-6-13-1-10-b":[],
	"qaneryaurci-6-13-2-1-a":[],
	"qaneryaurci-6-13-2-2-b":[],
	"qaneryaurci-6-13-2-3-a":[],
	"qaneryaurci-6-13-2-4-b":[],
	"qaneryaurci-6-13-2-5-a":[],
	"qaneryaurci-6-13-2-6-b":[],
	"qaneryaurci-6-13-3-1-a":[],
	"qaneryaurci-6-13-3-2-b":[],
	"qaneryaurci-6-13-3-3-a":[],
	"qaneryaurci-6-13-3-4-b":[],
	"qaneryaurci-6-13-3-5-a":[],
	"qaneryaurci-6-13-3-6-b":[],
	"qaneryaurci-6-13-3-7-a":[],
	"qaneryaurci-6-13-4-1-a":[],
	"qaneryaurci-6-13-4-2-b":[],
	"qaneryaurci-6-13-4-3-a":[],
	"qaneryaurci-6-13-4-4-b":[],
	"qaneryaurci-6-13-4-5-a":[],
	"qaneryaurci-6-13-4-6-b":[],
	"qaneryaurci-6-13-4-7-a":[],
	"qaneryaurci-6-13-4-8-b":[],
	"qaneryaurci-6-13-5-1-a":[],
	"qaneryaurci-6-13-5-2-b":[],
	"qaneryaurci-6-13-5-3-a":[],
	"qaneryaurci-6-13-5-4-b":[],
	"qaneryaurci-6-13-5-5-a":[],
	"qaneryaurci-6-17-1-1-a":[],
	"qaneryaurci-6-17-1-2-b":[],
	"qaneryaurci-6-17-1-3-a":[],
	"qaneryaurci-6-17-1-4-b":[],
	"qaneryaurci-6-17-1-5-a":[],
	"qaneryaurci-6-17-1-6-b":[],
	"qaneryaurci-6-17-1-7-a":[],
	"qaneryaurci-6-17-1-8-b":[],
	"qaneryaurci-6-17-2-1-a":[],
	"qaneryaurci-6-17-2-2-b":[],
	"qaneryaurci-6-17-2-3-a":[],
	"qaneryaurci-6-17-2-4-b":[],
	"qaneryaurci-6-17-2-5-a":[],
	"qaneryaurci-6-17-2-6-b":[],
	"qaneryaurci-6-17-2-7-a":[],
	"qaneryaurci-6-17-2-8-b":[],
	"qaneryaurci-6-17-2-9-a":[],
	"qaneryaurci-6-17-2-10-b":[],
	"qaneryaurci-6-17-2-11-a":[],
	"qaneryaurci-6-17-2-12-b":[],
	"qaneryaurci-6-17-2-13-a":[],
	"qaneryaurci-6-17-2-14-b":[],
	"qaneryaurci-6-17-2-15-a":[],
}




// WEBPACK FOOTER //
// ./src/components/constants/sentenceTransitionTimings.js